<template>
    <span class="navbar-toggler-icon">
        <slot />
    </span>
</template>

<script>
export default {

    name: 'NavbarTogglerIcon'

};
</script>
